import packageInfo from '../../package.json';

export const appInfo = {
  name: 'AI 网关管理平台',
  version: packageInfo.version,
  primaryColor: '#1677ff',
} as const;

export {
  appRoutes,
  defaultRoute,
  fallbackRoute,
  filterMenuItems,
  findRoute,
  flattenRoutes,
  menuItems,
  pageItems,
  protectedRoutes,
  publicRoutes,
  rootRoute,
} from './routes';
